import {AvField, AvForm} from "availity-reactstrap-validation";
import {FormGroup, Label} from "reactstrap";
import React from "react";
import {DatePicker, Select} from "antd";
import dayjs from 'dayjs';

const GeneralTab = ({couponCode, description, type, amount, validDateTo, validDateFrom, serviceValidDateTo, handleChange}) => {
  const discountOptions = ['Фиксирана отстъпка в лв.', 'Процентна отстъпка']
  return <AvForm className="needs-validation row">
    <FormGroup className="col-12">
      <Label htmlFor="validationCustom01">Код на купона</Label>
      <AvField
        name="couponCode"
        placeholder="Код на купона"
        type="text"
        errorMessage="Моля, въведете код на купона"
        className="form-control"
        onChange={(e) => {
          e.target.value = e.target.value.toUpperCase().replace(/[^\w-]+/g, '')
          handleChange(e)
        }}
        value={couponCode}
        validate={{required: {value: true}}}
        id="validationCustom01"
      />
    </FormGroup>
    <FormGroup className="col-12">
      <Label htmlFor="validationCustom01">Описание </Label>
      <AvField
        name='description'
        placeholder="Описание"
        type="textarea"
        rows={2}
        errorMessage="Моля, въведете описание"
        className="form-control"
        onChange={handleChange}
        value={description}
        validate={{required: {value: true}}}
        id="validationCustom02"
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom02">Вид отстъпка</Label>
      <Select
        placeholder="Вид отстъпка"
        name="type"
        value={type}
        onChange={(e) => handleChange({target: {name: 'type', value: e}})}
        className="w-100"
        options={discountOptions
          .map((item, i) => ({
            key: i,
            value: i,
            label: item,
          }))}
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom02">Стойност на купона</Label>
      <AvField
        name="amount"
        placeholder="Стойност на купона"
        type="text"
        errorMessage="Моля, въведете стойност на купона"
        className="form-control"
        onChange={handleChange}
        value={amount}
        validate={{required: {value: true}}}
        id="validationCustom01"
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom02">Валиден от</Label>
      <DatePicker
        placeholder="Начална дата"
        className='w-100'
        value={(validDateFrom ? dayjs(validDateFrom) : null)}
        formar={'DD-MM-YYYY'}
        onChange={(date, dateString) => {
          handleChange({target: {name: 'validDateFrom', value: dateString}})
        }}
      />
    </FormGroup>
    <FormGroup className="col-md-12 col-lg-6">
      <Label htmlFor="validationCustom02">Валиден до</Label>
      <DatePicker
        placeholder="Крайна дата"
        className='w-100'
        value={(validDateTo ? dayjs(validDateTo) : null)}
        formar={'DD-MM-YYYY'}
        onChange={(date, dateString) => {
          handleChange({target: {name: 'validDateTo', value: dateString}})
        }}
      />
    </FormGroup>
    <FormGroup className="col-12 ">
      <Label htmlFor="validationCustom02">Услугата важи до</Label>
      <DatePicker
        placeholder="Услугата важи до"
        className='w-100'
        value={(serviceValidDateTo ? dayjs(serviceValidDateTo) : null)}
        formar={'DD-MM-YYYY'}
        onChange={(date, dateString) => {
          handleChange({target: {name: 'serviceValidDateTo', value: dateString}})
        }}
      />
    </FormGroup>
  </AvForm>
}

export default GeneralTab
